import { FC, SVGProps } from 'react';

interface BrandIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/*
 * Znaki marek integracji w menu, wektorowe (ostre w każdej skali), w kolorach marek:
 * Stripe fiolet #635BFF, Oracle czerwień #C74634. Kształty: Simple Icons (CC0).
 */
export const StripeIcon: FC<BrandIconProps> = ({ size = 18, ...props }) => (
  <svg className="brand-icon" width={size} height={size} viewBox="0 0 24 24" fill="#635BFF" aria-hidden="true" focusable="false" {...props}>
    <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z" />
  </svg>
);

/* Oracle (OPERA Cloud to system Oracle Hospitality). */
export const OracleIcon: FC<BrandIconProps> = ({ size = 18, ...props }) => (
  <svg className="brand-icon" width={size} height={size} viewBox="0 0 24 24" fill="#C74634" aria-hidden="true" focusable="false" {...props}>
    <path d="M16.412 4.412h-8.82a7.588 7.588 0 0 0-.008 15.176h8.828a7.588 7.588 0 0 0 0-15.176zm-.193 12.502H7.786a4.915 4.915 0 0 1 0-9.828h8.433a4.914 4.914 0 1 1 0 9.828z" />
  </svg>
);
